<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import { fly } from 'svelte/transition';
	import Map from './Map.svelte';
	import SiteOfInterest from './SiteOfInterest.svelte';
	import {Places, PlaceDetails, selectedPlace } from "./places.js";
	import { Icon } from './feathericons.js';

	const startLocation = [52.0862573323384, 0.05833167150376184];
	const startZoom = 11;
	const dispatcher = createEventDispatcher();
	const place_search_name = "place";


	let markers = Places;
	let map;

	let location = startLocation;
	let zoom = startZoom;

	let selected;
	const unsubscribeToSelectedPlace = selectedPlace.subscribe(value => {
		selected = value;
	})

	const scrollTolerence = 30;
	let scrollY;

	function updateSelectedPlace(place)
	{
		selectedPlace.update(() => place);
	}

	onMount(() => {
		let params = new URLSearchParams(window.location.search);
		if(params.get(place_search_name))
		{
			let marker = params.get(place_search_name);
			let details = PlaceDetails[marker];

			if(details)
			{
				selected = details;
				location = details.location
				zoom = details.zoom;
				markers = details.places;
				updateSelectedPlace(marker);
			}
		}
	});

	function onMarkerClick(marker)
	{
		console.log(marker);
		let details = PlaceDetails[marker];

		if(details)
		{
			selected = details;
			location = details.location
			zoom = details.zoom;
			markers = details.places;
			updateSelectedPlace(marker);

			const url = new URL(window.location);
			url.searchParams.set(place_search_name, marker);
			window.history.pushState({}, '', url);

		}
		else {
			let target = document.getElementById(marker);
			if(target)
			{
				target.scrollIntoView({behavior:'smooth'});
			}
		}
	}

	function scrollTo(target)
	{
		if(!target)
		{
			target = 0;
		}

		window.scroll({
		  top: target,
		  behavior: 'smooth'
		});
	}

	function resetMap()
	{
		location = startLocation;
		zoom = startZoom;
		markers = Places;
		updateSelectedPlace(null);
		const url = new URL(window.location);
		url.searchParams.delete(place_search_name)
		window.history.pushState({}, '', url);
		scrollTo(0);
	}

	$: placeSelected = selected !== null;

	function onMapClick(e)
	{
		console.log(e.latlng);
	}

</script>

<style>

	.abs-butt
	{
		position:fixed;
		top:90%;
		right:10%;

	}
</style>

<svelte:window bind:scrollY={scrollY} />

<Map bind:this={map} lon={location[0]} lat={location[1]} zoom={zoom}>
	{#each markers as marker (marker.label) }
		<SiteOfInterest label={marker.label} location={marker.location} click={onMarkerClick} />
	{/each}
</Map>
{#if placeSelected}
<div class="button button-primary" transition:fly={{x:-200, duration:500}} on:click={resetMap}>{@html Icon("arrow-left","small-white")}Back</div>
{/if}

{#if scrollY >= scrollTolerence}
<div class="button button-primary abs-butt" transition:fly={{y:200, duration:500}} on:click={scrollTo}>{@html Icon("arrow-up","small-white")}Up</div>
{/if}
